var exports = {
  "b": "LexicalChannelTextareaContent.module__composerHost___MkJZMk",
  "F": "LexicalChannelTextareaContent.module__composerEditable___MkJZMk",
};

module.exports = exports;
